// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HifyYu1jnDU8SoeaClqd{width:100%}.yhwqJFuM6kNjqMgQzaJR{border-bottom:1px solid var(--border-neutral-default);align-items:center;gap:16px;height:48px;display:flex}.emuKXbG4_I8lh_aBwBrH{width:35px;color:var(--content-primary-tertiary);flex:0 0 35px}.SC2YpdmwocAr53vN3rKY{background-color:var(--background-primary-inverted-primary);border:1px solid var(--border-neutral-default);border-radius:6px;align-items:center;gap:8px;padding:4px 8px;display:flex}.hN3tpCYJfPE_Yu6AVy04{color:var(--content-primary-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `HifyYu1jnDU8SoeaClqd`,
	"box": `yhwqJFuM6kNjqMgQzaJR`,
	"label": `emuKXbG4_I8lh_aBwBrH`,
	"blockContact": `SC2YpdmwocAr53vN3rKY`,
	"blockContact__label": `hN3tpCYJfPE_Yu6AVy04`,
	"blockContactLabel": `hN3tpCYJfPE_Yu6AVy04`
};
export default ___CSS_LOADER_EXPORT___;
